import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import Register from './views/Register.vue'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'Login',
			component: () => import('./views/Login.vue')
		},
		{
			path: '/deviceList',
			component: Main,
			children: [{
				path: '/deviceList',
				component: () => import('./components/deviceList.vue')
			}]
		},
		{
			path: '/testRecord',
			component: Main,
			children: [{
				path: '/testRecord',
				component: () => import('./components/testRecord.vue')
			}]
		},
		{
			path: '/index',
			name: 'Index',
			component: () => import('./views/Index6.vue')
		},
		{
			path: '/exportReport',
			name: 'exportReport',
			component: () => import('./components/exportReport.vue')
		},
		{
			path: '/register',
			name: 'Register',
			component: Register
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('./views/Login.vue')
		},
		{
			path: '/404',
			name: '404',
			component: () => import('./views/404.vue')
		},
		{
			path: '/500',
			name: '500',
			component: () => import('./views/500.vue')
		},
		{
			path: '/test',
			component: Main,
			children: [{
				path: '/test',
				component: () => import('./views/test.vue')
			}]
		},
		{
			path: '/test2',
			component: Main,
			children: [{
				path: '/test2',
				component: () => import('./views/test2.vue')
			}]
		},
		{
			path: '/exportReport2',
			name: 'exportReport2',
			component: () => import('./components/exportReport2.vue')
		},
		{
			path: '/exportReport3',
			name: 'exportReport3',
			component: () => import('./components/exportReport3.vue')
		},
		{
			path: '/exportReport4',
			name: 'exportReport4',
			component: () => import('./components/exportReport4.vue')
		},
	]
})

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}